var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpCircleContained(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99927 12.6826V12.7123M7.3125 7.23011C7.3125 6.28053 8.06802 5.51074 9 5.51074C9.93198 5.51074 10.6875 6.28053 10.6875 7.23011C10.6875 8.1797 9.93198 8.94948 9 8.94948C9 8.94948 8.99927 9.46268 8.99927 10.0957M15.75 9.30762C15.75 13.0355 12.7279 16.0576 9 16.0576C5.27208 16.0576 2.25 13.0355 2.25 9.30762C2.25 5.57969 5.27208 2.55762 9 2.55762C12.7279 2.55762 15.75 5.57969 15.75 9.30762Z",
    stroke: "#1B4DFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCircleContained);
export default __webpack_public_path__ + "static/media/help-circle-contained.dc02935628918188ed423766d239b11c.svg";
export { ForwardRef as ReactComponent };